import React, { useState, useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const [score, setScore] = useState()
  const { openNotification } = hooks.useNotification()
  const [, setStep] = hooks.useFormState('step')
  const isSubmitting = hooks.useFormStatus('isSubmitting')
  const [, signin] = hooks.useAuthFunction('signin')
  const [email, password] = hooks.useFieldValues(['email', 'password'])
  const [visible, setVisible] = useState(false)
  const onVisibleChange = useCallback(() => setVisible(!visible), [visible, setVisible])

  const onRequestSubmit = useCallback(Callbacks.onRequestSubmitHandler(setStep, signin, openNotification, email, password, score), [setStep, signin, openNotification, email, password, score])
  const mergedProps = {
    setScore,
    visible,
    onVisibleChange,
    onRequestSubmit,
    isSubmitting,
    password
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer
